import {FaEllipsisVertical} from "react-icons/fa6";
import DropdownButton from "../../../../components/button/dropdown-button.jsx";

export default function FolderButton({ item, name, icon: Icon, iconColorClassName = "text-[#396694]", onOpen, buttonOptions = [], isSelected = false, onSelect }) {
    const optionsWithItem = buttonOptions.map((option) => ({
        ...option,
        disabled: typeof option.disabled === "function" ? option.disabled(item) : option.disabled,
        successText: typeof option.successText === "function" ? option.successText(item) : option.successText,
        onClick: () => option.onClick(item),
    }));

    return (
        <div
            role="button"
            title={name}
            tabIndex={0}
            onClick={(event) => {
                event.stopPropagation();
                onSelect(event);
            }}
            onDoubleClick={onOpen}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onOpen();
                }
            }}
            className={`
                h-12 w-full rounded-xl 
                flex items-center gap-3 pl-4 pr-2
                cursor-pointer 
                focus:outline-none focus:ring-2 focus:ring-[#93C5FD]
                transition-all duration-200 ease-in-out
                ${isSelected ? "bg-[#E5E7EB]" : "bg-[#F9FAFB] hover:bg-[#E5E7EB]"}
            `}
        >
            <Icon size={28} className={`shrink-0 ${iconColorClassName}`} />
            <span className="min-w-0 flex-1 font-medium text-base truncate select-none">{name}</span>
            <DropdownButton
                buttonContent={<FaEllipsisVertical />}
                buttonClassName="
                    flex h-10 w-10 shrink-0 items-center justify-center
                    rounded-full bg-transparent cursor-pointer
                    hover:bg-[#d1d5db] transition-colors duration-200 ease-in-out
                "
                menuClassName="!z-[1000]"
                items={optionsWithItem}
            />
        </div>
    )
}